import React, { useState, useRef } from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faBars,
  faTimes,
} from '@fortawesome/free-solid-svg-icons';
import Logo from '../components/Logo';
import Services from '../pages/Services/Services';
import AboutUsCard from '../pages/About/AboutUsCard';
import SolutionCard from '../pages/Solutions/SolutionCard';
import ProductsCard from '../pages/Products/ProductsCard';

const Header = () => {
  const [isOpen, setIsOpen] = useState(false);
  const hoverContainerRef = useRef(null);
  const [isHovered, setIsHovered] = useState(false);


  const handleMouseOver = () => {
    if (hoverContainerRef.current) {
      hoverContainerRef.current.classList.add('persistent-hover');
    }
  };

  const handleMouseOut = () => {
    if (hoverContainerRef.current) {
      setTimeout(() => {
        if (hoverContainerRef.current) {
          hoverContainerRef.current.classList.remove('persistent-hover');
        }
      }, 300);
    }
  };
 

  return (
    <div
      className="fixed top-0 w-full bg-white shadow-md z-50 font-nunito font-bold"
      onMouseOver={handleMouseOver}
      onMouseOut={handleMouseOut}
      ref={hoverContainerRef}
    >

<header className="bg-white text-black p-1 relative mr-8">
  <nav className="p-1 bg-white md:flex md:items-center md:justify-between relative">
    <div className="flex justify-between items-center">
      <Logo
        height="50px"
        width="auto"
        className="cursor-pointer"
      />
      <div className="text-3xl cursor-pointer mx-2 md:hidden block">
        <button
          onClick={() => setIsOpen(!isOpen)}
          className="focus:outline-none"
          aria-label="Toggle Menu"
        >
          <FontAwesomeIcon icon={isOpen ? faTimes : faBars} />
        </button>
      </div>
    </div>

    <ul
      className={`md:flex md:items-center md:w-auto md:space-x-4 md:ml-auto ${
        isOpen ? 'block' : 'hidden'
      } mt-4 md:mt-0`}
    >
      <li className="mx-4 my-6 md:my-0 relative">
        <Link
          to={'/AboutUsHome'}
        // onClick={()=>setIsOpen(false)}// Close the menu on click
          className="text-md hover:text-black-500 duration-500 w-full max-w-6xl mx-auto sm:w-11/12 md:w-9/12 lg:w-8/12 xl:w-7/12"
        >
          <AboutUsCard />
        </Link>
      </li>
      <li className="mx-4 my-6 md:my-0">
        <Link
          to={'/Products'}
          className="text-md hover:text-black-500 duration-500 w-full max-w-6xl mx-auto sm:w-11/12 md:w-9/12 lg:w-8/12 xl:w-7/12"
        >
          <ProductsCard />
        </Link>
      </li>
      <li className="mx-4 my-6 md:my-0">
        <Link
          to={'/ServiceHome'}
          className="text-md hover:text-black-500 duration-500 w-full max-w-6xl mx-auto sm:w-11/12 md:w-9/12 lg:w-8/12 xl:w-7/12"
        >
          <Services />
        </Link>
      </li>
      <li className="mx-4 my-6 md:my-0">
        <Link
          to={'/Solutions'}
          className="text-md hover:text-black-500 duration-500 w-full max-w-6xl mx-auto sm:w-11/12 md:w-9/12 lg:w-8/12 xl:w-7/12"
        >
          <SolutionCard />
        </Link>
      </li>
      <li className="mx-4 my-6 md:my-0"
          onMouseEnter={() => setIsHovered(true)} 
          onMouseLeave={() => setIsHovered(false)}>
        <Link 
          to="/ContactPage"
          onClick={() => setIsOpen(false)} // Close the menu on click
        >
          <button className={`relative px-2 py-2 text-gray-600 bg-white rounded ease-in-out transform focus:outline-none font-normal 
              after:content-[''] after:absolute after:left-0 after:bottom-0 after:w-full after:h-[2px] after:transition-all after:duration-3000 
              ${isHovered ? 'hover:scale-110 after:bg-blue-500 text-blue-500 after:w-full' : 'after:bg-transparent'}`}>
            Contact Us
          </button>
        </Link>
      </li>
    </ul>
  </nav>
</header>

    </div>
  );
};

export default Header;
